

/**
 * @component Form
 * @deprecated Please use ui-kit/components/form
 * @public
 */

export default {
  name: 'Form',
  methods: {
    /**
     * Prevent default submit behavior and parse form data.
     *
     * @private
     */

    submit(e) {
      e.preventDefault();
      this.$emit('submit', form(e.target), e);
    },
  },
};

/**
 * Return form object containing as the input (identified by their name) and their values.
 *
 * @param {Element} target
 * @return {Object}
 * @public
 */

function form(target) {
  const result = {};
  const selectedMultipleCheckboxes = [];
  const elements = [
    ...target.querySelectorAll('input'),
    ...target.querySelectorAll('textarea'),
  ];
  elements.forEach((input) => {
    const {
      name, type, value, checked, className,
    } = input;
    if (type === 'radio') {
      if (checked) result[name] = value;
    } else if (type === 'checkbox') {
      // If we need to select more than one value from group of checkboxes.
      // Not only true or false
      if (className === 'multiple') {
        if (checked) {
          selectedMultipleCheckboxes.push(value);
          result[name] = JSON.stringify(selectedMultipleCheckboxes);
        }
      } else {
        result[name] = checked;
      }
    } else {
      result[name] = value;
    }
  });

  return result;
}
